<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useAuthStore } from "@/stores/auth";
import { computed, onMounted } from "vue";
import { ElConfigProvider } from "element-plus";
import en from "element-plus/es/locale/lang/en";
import ru from "element-plus/es/locale/lang/ru";
import uz from "element-plus/es/locale/lang/uz-uz";

const { locale } = useI18n();
const auth = useAuthStore();

// Element Plus needs its own locale objects — map our 3 locales to theirs.
const elementLocale = computed(() => {
  switch (locale.value) {
    case "uz": return uz;
    case "ru": return ru;
    default:   return en;
  }
});

onMounted(() => {
  // Rehydrate auth from localStorage on first load so a hard refresh
  // doesn't kick the user back to /login.
  auth.restore();
});
</script>

<template>
  <ElConfigProvider :locale="elementLocale">
    <RouterView />
  </ElConfigProvider>
</template>
